import React from 'react';
import i18n from 'i18n';
import { BlazeTableColDef } from 'components/blazeTable/BlazeTable.types';
import { ProcessingAction } from 'types/rest/assetCatalogTypes';
import ExpandLink from 'components/blazeTable/ExpandLink';
import clsx from 'clsx';
import styles from 'views/AssetCatalog/Transactions/TransactionEditor/Transactions.module.css';
import { Button } from 'react-bootstrap';
import BzmIcon from 'components/icons/BzmIcon';
import BlazeTableActions from 'components/blazeTable/BlazeTableActions';
import DraggableTable from 'components/blazeTable/Draggable/DraggableTable';
import { ProcessingActionTableOptions } from '../ProcessingActions';
import { getProcessingActionType } from '../CommonActions';
import ConditionsCell from './ConditionsCell';
import BlazeTable from 'components/blazeTable/BlazeTable';

type ProcessingActionsTableProps = {
  processingActionList: ProcessingAction[];
  deleteAction: (pa: ProcessingAction) => void;
  onSelect: (selectedItems: Array<any>) => void;
  onEdit: (pa: ProcessingAction) => void;
  tableOptions?: ProcessingActionTableOptions;
  onDragFinished: (items: any[]) => void;
  isLoading: boolean;
};

const ProcessingActionsTable = (props: ProcessingActionsTableProps) => {
  const getTableColumns = () => {
    // Definition of table columns
    const colsDefinition: BlazeTableColDef[] = [];

    if (props.tableOptions?.columns.name === true) {
      colsDefinition.push({
        header: i18n.t('transactions:processingActions.table.name'),
        accessor: 'name',
        cellComponent: (rowData: ProcessingAction) => {
          return (
            <ExpandLink
              value={rowData.name || ''}
              id={rowData.id as number}
              title={rowData.name}
              onToggleExpandDetail={() => {
                props.onEdit(rowData);
              }}
            />
          );
        },
      });
    }

    if (props.tableOptions?.columns.type === true) {
      colsDefinition.push({
        header: i18n.t('transactions:processingActions.table.type'),
        accessor: 'type',
        cellComponent: (processingAction: ProcessingAction) => getProcessingActionType(processingAction.actionType),
      });
    }

    if (props.tableOptions?.columns.conditions === true) {
      colsDefinition.push({
        header: i18n.t('transactions:processingActions.table.conditions'),
        accessor: 'conditions',
        cellComponent: (processingAction: ProcessingAction) => (
          <ConditionsCell conditions={processingAction.conditions} />
        ),
      });
    }

    if (props.tableOptions?.columns.actions === true) {
      colsDefinition.push({
        header: i18n.t('transactions:processingActions.table.action'),
        width: 80,
        accessor: 'action',
        cellComponent: (processingAction: ProcessingAction) => {
          return (
            <BlazeTableActions>
              <Button
                disabled={false}
                variant={'link'}
                id={`qa-tbl-row-delete-action-${processingAction.id}`}
                className="btn btn-link-dark btn-no-hover p-2"
                title={i18n.t('transactions:processingActions.table.deleteBtn')}
                onClick={() => props.deleteAction(processingAction)}
              >
                <BzmIcon variant={'icon-bzm-delete'} className={clsx('icon-xs', styles.blackIcons)} />
                <span className="sr-only">${i18n.t('transactions:processingActions.table.deleteBtn')}</span>
              </Button>
            </BlazeTableActions>
          );
        },
      });
    }

    return colsDefinition;
  };

  return (
    <div style={{ paddingBottom: '40px' }}>
      {props.tableOptions.isSimple ? (
        <BlazeTable
          data={props.processingActionList}
          isLoading={props.isLoading}
          options={{ showRowExpander: false, pageable: false, selectable: false, columnDef: getTableColumns() }}
        />
      ) : (
        <DraggableTable
          onSelectionChange={props.onSelect}
          cols={getTableColumns()}
          data={props.processingActionList}
          onDragFinished={props.onDragFinished}
          isLoading={props.isLoading}
        />
      )}
    </div>
  );
};

export default ProcessingActionsTable;
